import { SourceConfig } from '../types';
import salesforceLogo from '../../../../../images/logo-salesforce.svg';

const placeholderRecipe = `\
source: 
    type: salesforce
    config:
        # Coordinates
        instance_url: # Your Salesforce Instance Url, e.g. https://test.my.salesforce.com

        # Credentials
        # Add secret in Secrets Tab with relevant names for each variable
        consumer_key: "\${CONSUMER_KEY}" # Your Salesforce key, e.g. admin
        consumer_secret: "\${CONSUMER_SECRET}" # Your Salesforce secret, e.g. password_01

        # Profiling
        profiling:
            enabled: false
        stateful_ingestion:
            enabled: true    
`;

export const SALESFORCE = 'salesforce';

const salesforceConfig: SourceConfig = {
    type: SALESFORCE,
    placeholderRecipe,
    displayName: 'Salesforce CRM',
    docsUrl: 'https://datahubproject.io/docs/generated/ingestion/sources/salesforce/',
    logoUrl: salesforceLogo,
};

export default salesforceConfig;
